import type { ReactNode } from 'react';

export const symbol_man_4: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m416-106-67-499q-4-27 14.29-47.5Q381.57-673 409-673h142q27.43 0 45.71 20.5Q615-632 611-605l-67 499q-2 11-10.6 18.5-8.61 7.5-19.83 7.5h-67.35Q435-80 426.5-87.5 418-95 416-106Zm64.08-628q-30.08 0-51.58-21.42t-21.5-51.5q0-30.08 21.42-51.58t51.5-21.5q30.08 0 51.58 21.42t21.5 51.5q0 30.08-21.42 51.58t-51.5 21.5Z"
		/>
	</svg>
);
